<main cdkDropList      (cdkDropListDropped)="drop($event)">
  <h3>{{'previewQuestion' | translation}}</h3>
  <div cdkDrag class="listElement" *ngFor="let data of questionList.data; let i = index" (click)="expandQuestion.emit(this.questionList.id[data.priority])" [ngClass]="{'opened': getOpenedQuestion(questionList.id[i])}">
    <div class="dragHandleElement">
      <mat-icon cdkDragHandle>drag_indicator</mat-icon>
    </div>
    <div class="questionElement">
      <span class="title">{{'question' | translation}} {{data.priority + 1}} - {{data.type | translation}}</span>
      <span class="subtitle">{{data.label}}</span>
    </div>
  </div>
</main>
